<style lang="scss" scoped>
.card-table {
  margin-bottom: 0;
}
</style>

<template>
  <section>
    <v-table
      url="/api/v1/customerProfile"
      :filter="[
        {
          name: 'coupon',
          value: id
        }
      ]"
      :attributes="[
        {
          attribute: 'name',
          name: 'Name'
        },
        {
          attribute: 'coupons[0].pivot.created_at',
          name: 'Eingelöst am',
          type: 'DateTimeCell'
        }
      ]"
    ></v-table>
  </section>
</template>

<script lang="babel">
export default {
  props: ["id"]
};
</script>
